import { memo } from "react";
import { C_OUTLINE_VARIANT, C_SURFACE, C_SURFACE_BRIGHT } from "~/common/components/icon/Colors";
import { TanStackTable } from "~/common/components/Table/TanStackTable";
import styled from "@emotion/styled";

export const NewOrderBookTable = styled(memo(TanStackTable))({
  border: `1px solid ${C_OUTLINE_VARIANT}`,
  borderBottom: `none !important`,
  borderRadius: `12px 12px 0 0`,
  overflow: "clip",

  table: {
    borderCollapse: "separate",
  },
  thead: {
    background: C_SURFACE,
  },
  ["tbody > .evenRow > td"]: {
    background: `${C_SURFACE_BRIGHT} !important`,
  },
  td: {
    padding: "8px !important",
    borderTop: `none !important`,
    ["&:last-child"]: {
      borderRight: `none !important`,
    },
    wordBreak: "break-word",
  },
  th: {
    verticalAlign: "middle",
    borderTop: `none !important`,
    borderBottom: `2px solid ${C_OUTLINE_VARIANT} !important`,
    paddingLeft: `8px !important;`,

    ["&:last-child"]: {
      borderRight: `none !important`,
    },
  },

  button: {
    flexDirection: "row-reverse",
  },

  [".scroll-slider__root"]: {
    borderRadius: `12px 12px 0 0`,
    backgroundColor: C_SURFACE,
  },

  ['&[data-stuck="true"] .scroll-slider__root']: {
    borderRadius: 0,
  },

  ".action-cell": {
    opacity: 0,
    transition: "opacity 0.2s ease",
  },

  "tbody tr:hover .action-cell": {
    opacity: 1,
  },
}) as typeof TanStackTable;
